import React from 'react';
import { Button } from '../UI/Button';
export const Newsletter = () => {
  return <section className="py-16 bg-secondary/5" data-id="element-515" data-mp="3eo5t353wdu36">
      <div className="container mx-auto px-4" data-id="element-516" data-mp="3emujupronu4o">
        <div className="max-w-3xl mx-auto text-center" data-id="element-517" data-mp="2zz9eep7c5itl">
          <h2 className="text-3xl font-bold mb-6 text-secondary-dark" data-id="element-518" data-mp="2zyq702fbactt">
            Stay Connected
          </h2>
          <p className="text-secondary mb-8" data-id="element-519" data-mp="34wja2mlbiqpv">
            Subscribe to our newsletter for the latest events, opportunities,
            and success stories.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-520" data-mp="2vyfr9y1pw81r">
            <input type="email" placeholder="Enter your email address" className="flex-grow px-4 py-2 border border-gray-300 rounded-md focus:border-primary focus:ring-2 focus:ring-primary/20 outline-none" data-id="element-521" data-mp="2h0nbr5w67jnk" />
            <Button data-id="element-522" data-mp="f8iq2c59lila">Subscribe</Button>
          </div>
        </div>
      </div>
    </section>;
};